import Vue from "vue";
import VueRouter from "vue-router";
import NavBar from "../views/NavBar.vue";
import Swal from "sweetalert2";
import Home from "../views/Home.vue";

const PRDetail = () => import("@/components/HomePage/PRDetail.vue");

// About us
const History = () => import("@/components/AboutUs/History.vue");
// const ServiceVision = () => import("@/components/AboutUs/ServiceVision.vue");
// const ResearchVision = () => import("@/components/AboutUs/ResearchVision.vue");
// const AcademicVision = () => import("@/components/AboutUs/AcademicVision.vue");
const VisionAndMission = () => import("@/components/AboutUs/VisionAndMission.vue");
const VisionMain = () => import("@/components/AboutUs/VisionMain.vue");
const StructureMajor = () => import("@/components/AboutUs/StructureMajor.vue");
const Recreation = () => import("@/components/AboutUs/Recreation.vue");
const RecreationDetail = () => import("@/components/AboutUs/RecreationDetail.vue");
const ResidenceMajor = () => import("@/components/AboutUs/ResidenceMajor.vue");
const Alumni = () => import("@/components/AboutUs/Alumni.vue");
const AlumniNurse = () => import("@/components/AboutUs/AlumniNurse.vue");
const Customer = () => import("@/components/AboutUs/Customer.vue");

// Personnel
const Anesthesiologist = () => import("@/components/Personnel/Anesthesiologist.vue");
const AnesthetistNurse = () => import("@/components/Personnel/AnesthetistNurse.vue");
const ScienceOfficer = () => import("@/components/Personnel/ScienceOfficer.vue");
const AnesthesiologyStaff = () => import("@/components/Personnel/AnesthesiologyStaff.vue");
const Doctors = () => import("@/components/Personnel/Doctors.vue");
const Nurse = () => import("@/components/Personnel/Nurse.vue");

// Service
const Annualreport = () => import("@/components/Service/AnnualReport.vue");
const Schedule = () => import("@/components/Service/Schedule.vue");
const ActivityCalendar = () => import("@/components/Service/ActivityCalendar.vue");
const Download = () => import("@/components/Service/Download.vue");

// Research
const InternationalResearch = () => import("@/components/Research/InternationalResearch.vue");
const NationalResearch = () => import("@/components/Research/NationalResearch.vue");
const Researching = () => import("@/components/Research/Researching.vue");
const Invention = () => import("@/components/Research/Invention.vue");
const Poster = () => import("@/components/Research/Poster.vue");
const Abstract = () => import("@/components/Research/Abstract.vue");


// Course
const Bachelor = () => import("@/components/Course/Bachelor.vue")
const SpecializedCourses = () => import("@/components/Course/SpecializedCourses.vue")
const AcademicServices = () => import("@/components/Course/AcademicServices.vue")
const CalendarWeek = () => import("@/components/Course/CalendarWeek.vue")
const CalendarWeekDetail = () => import("@/components/Course/CalendarWeekDetail.vue")

// News
const NewsAndEvent = () => import("@/components/NewsAndEvent/NewsAndEvent.vue")
const Academic = () => import("@/components/NewsAndEvent/Academic.vue")
const DoctorNews = () => import("@/components/NewsAndEvent/DoctorNews.vue")
const HospitalNews = () => import("@/components/NewsAndEvent/HospitalNews.vue")
const MedStudentNews = () => import("@/components/NewsAndEvent/MedStudentNews.vue")
const NurseNews = () => import("@/components/NewsAndEvent/NurseNews.vue")
const AllNews = () => import("@/components/NewsAndEvent/AllNews.vue")
const NewsAndEventDetail = () => import("@/components/NewsAndEventDetail.vue")


// Excellent and Sub-Units
const Excellent = () => import("@/components/SubUnits/Excellent.vue")
const SubUnits = () => import("@/components/SubUnits/SubUnits.vue")
//Register
const Register = () => import("@/components/Register.vue")


// User Management
const UserManagement = () => import("@/components/UserManagement.vue")



Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Navbar",
    component: NavBar,
    children: [

      {
        path: "/home",
        name: "Home",
        component: Home
      },

      {
        path: "/prdetail",
        name: "PR Detail",
        component: PRDetail
      },

      // About us
      {
        path: "/history",
        name: "History",
        component: History
      },
      // {
      //   path: "/visionandmission/servicevision",
      //   name: "Service Vision",
      //   component: ServiceVision
      // },
      // {
      //   path: "/visionandmission/researchvision",
      //   name: "Research Vision",
      //   component: ResearchVision
      // },
      // {
      //   path: "/visionandmission/academicvision",
      //   name: "Academic Vision",
      //   component: AcademicVision
      // },
      {
        path: "/visionandmission_general",
        name: "GeneralVision",
        component: VisionAndMission
      },
      {
        path: "/visionandmission/:mode",
        name: "VisionMain",
        component: VisionMain
      },
      {
        path: "/structure",
        name: "StructureMajor",
        component: StructureMajor
      },
      {
        path: "/recreation",
        name: "Recreation",
        component: Recreation
      },
      {
        path: "/recreation/detail",
        name: "Recreation Detail",
        component: RecreationDetail
      },
      {
        path: "/residence",
        name: "ResidenceMajor",
        component: ResidenceMajor
      },
      {
        path: "/alumni",
        name: "Alumni",
        component: Alumni
      },
      {
        path: "/alumninurse",
        name: "Alumni Nurse",
        component: AlumniNurse
      },
      {
        path: "/customer",
        name: "Customer",
        component: Customer
      },
      // Service
      {
        path: "/annualreport",
        name: "Annualreport",
        component: Annualreport
      },
      {
        path: "/schedule",
        name: "Schedule",
        component: Schedule
      },
      {
        path: "/activitycalendar",
        name: "Activity Calendar",
        component: ActivityCalendar
      },

      {
        path: "/download",
        name: "Download",
        component: Download
      },

      // Research
      {
        path: "/international/research",
        name: "International Research",
        component: InternationalResearch
      },
      {
        path: "/national/research",
        name: "National Research",
        component: NationalResearch
      },
      {
        path: "/researching",
        name: "Researching",
        component: Researching
      },
      {
        path: "/invention",
        name: "Invention",
        component: Invention
      },
      {
        path: "/poster",
        name: "Poster",
        component: Poster
      },
      {
        path: "/abstract",
        name: "Abstract",
        component: Abstract
      },


      // Course
      {
        path: "/bachelor",
        name: "Bachelor",
        component: Bachelor
      },
      {
        path: "/specializedcourses",
        name: "Specialized Courses",
        component: SpecializedCourses
      },
      {
        path: "/academicservices",
        name: "Academic Services",
        component: AcademicServices
      },
      {
        path: "/calendarweek",
        name: "Calendar Week",
        component: CalendarWeek
      },
      {
        path: "/calendarweekdetail",
        name: "CalendarWeekDetail",
        component: CalendarWeekDetail
      },

      // Personnel
      {
        path: "/anesthesiologist",
        name: "Anesthesiologist",
        component: Anesthesiologist
      },
      {
        path: "/nurseanesthetist",
        name: "AnesthetistNurse",
        component: AnesthetistNurse
      },
      {
        path: "/scienceofficer",
        name: "Science Officer",
        component: ScienceOfficer
      },
      {
        path: "/Anesthesiologystaff",
        name: "Anesthesiology Staff",
        component: AnesthesiologyStaff
      },
      {
        path: "/doctors",
        name: "Doctors",
        component: Doctors
      },
      {
        path: "/nurse",
        name: "Nurse",
        component: Nurse
      },

      // News

      {
        path: "/newsandevent",
        name: "NewsAndEvent",
        component: NewsAndEvent
      },
      {
        path: "/academic",
        name: "Academic",
        component: Academic
      },
      {
        path: "/doctor",
        name: "Doctor News",
        component: DoctorNews
      },
      {
        path: "/hospital",
        name: "Hospital News",
        component: HospitalNews
      },
      {
        path: "/medstudent",
        name: "Med Student News",
        component: MedStudentNews
      },
      {
        path: "/nursenews",
        name: "Nurse News",
        component: NurseNews
      },
      {
        path: "/allnews",
        name: "All News",
        component: AllNews
      },

      {
        path: "/newsandevent_detail/detail",
        name: "NewsAndEventDetail",
        component: NewsAndEventDetail
      },
      // Excellent and Sub Units
      {
        path: "/excellent",
        name: "Excellent",
        component: Excellent
      },
      {
        path: "/subunits",
        name: "Sub Units",
        component: SubUnits
      },
      // Register
      {
        path: "/register",
        name: "Register",
        component: Register
      },
      // UserManagement
      {
        path: "/user_management",
        name: "User Management",
        component: UserManagement
      },
      {
        path: "/",
        name: "noPath",
        redirect: '/home',
        component: Home
      },
      {
        path: "/*",
        name: "otherPath",
        redirect: '/home',
        component: Home
      },
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});

export default router;
router.beforeEach((to, from, next) => {
  // console.log("router");

  if (!Vue.prototype.$session.get("token")) {
    next();
  } else {
    // const session time 2 Hour.
    const sessionTime_DIFFERENCE = 2 * 60 * 60 * 1000;
    // old session time
    var sessionTime_OLD = Vue.prototype.$session.get("sessionTime");
    // now time
    var sessionTime_NOW = new Date();
    // console.log(sessionTime_OLD);

    // now - old > diff OR not have session Timeout
    if (
      sessionTime_NOW - Date.parse(sessionTime_OLD) >
      sessionTime_DIFFERENCE
    ) {
      Swal.fire(
        "Session Timeout",
        "หมดเวลา Session กรุณา Login ใหม่",
        "warning"
      ).then(result => {
        // console.log("sessionTimeOut");
        Vue.prototype.$session.clear();
        next("/home");
        window.location.reload();
      });
    } else {
      Vue.prototype.$session.set("sessionTime", sessionTime_NOW);
      next();
    }
  }
});
